import { render, staticRenderFns } from "./MainCheckbox.vue?vue&type=template&id=4b984a52&scoped=true"
import script from "./MainCheckbox.vue?vue&type=script&lang=js"
export * from "./MainCheckbox.vue?vue&type=script&lang=js"
import style0 from "./MainCheckbox.vue?vue&type=style&index=0&id=4b984a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b984a52",
  null
  
)

export default component.exports